import { h, apiClient, card, pill, btn } from './_common.js';

export async function renderAjustes(root) {
  root.innerHTML = '';
  const wrap = h('div', { class: 'animate-fade-in max-w-3xl' }, [
    h('h2', { class: 'font-display text-3xl font-bold mb-6' }, '⚙️ Ajustes'),
    h('div', { id: 'settings-list' }),
  ]);
  root.appendChild(wrap);
  const list = wrap.querySelector('#settings-list');

  const me = await apiClient.get('/api/v1/profile').catch(() => null);

  // Perfil
  list.appendChild(card('Perfil', { subtitle: 'Tus datos básicos' }));
  list.appendChild(h('div', { class: 'mb-6 -mt-3 pl-5 text-sm space-y-1' }, [
    h('div', {}, [h('strong', {}, 'Email: '), me?.user?.email || '—']),
    h('div', {}, [h('strong', {}, 'Nombre: '), me?.user?.fullName || '—']),
    h('div', {}, [h('strong', {}, 'Apodo: '), me?.user?.nickname || '—']),
    h('div', {}, [h('strong', {}, 'Ciudad: '), me?.user?.city || '—']),
  ]));

  // Cambiar contraseña
  list.appendChild(passwordSection());

  // 2FA
  list.appendChild(await twoFactorSection());

  // Importar datos
  list.appendChild(importSection());

  // Integraciones
  const ints = await apiClient.get('/api/v1/integrations').catch(() => []);
  list.appendChild(card('Integraciones', { subtitle: 'API keys guardadas (encriptadas AES-256-GCM)' }));
  if (!Array.isArray(ints) || ints.length === 0) {
    list.appendChild(h('p', { class: '-mt-3 mb-6 pl-5 text-sm text-ink-300' }, 'Sin integraciones registradas. Las API keys que ya pasaste están en el .env del VPS.'));
  } else {
    list.appendChild(h('div', { class: '-mt-3 mb-6 pl-5 space-y-1' },
      ints.map((i) => h('div', { class: 'flex items-center gap-2 text-sm' }, [
        pill(i.provider, 'gold'),
        h('span', { class: 'text-ink-300' }, i.label || '—'),
        i.isActive ? pill('activa', 'green') : pill('inactiva', 'gray'),
      ])),
    ));
  }

  // OpenClaw
  list.appendChild(card('Hub IA — OpenClaw', { subtitle: 'Multi-canal: Telegram, WhatsApp, iMessage, etc.' }));
  list.appendChild(h('div', { class: '-mt-3 mb-6 pl-5 text-sm space-y-1' }, [
    h('div', {}, ['Estado: ', pill('vivo', 'green')]),
    h('div', {}, ['Web UI: ', h('a', { href: '/chat/', target: '_blank', class: 'text-gold-400 underline' }, '/chat/')]),
    h('div', {}, ['Telegram bot: ', pill('configurado', 'green')]),
  ]));

  // Superpowers
  list.appendChild(card('Superpowers instaladas', { subtitle: 'Servicios extra del stack' }));
  list.appendChild(h('div', { class: '-mt-3 mb-6 pl-5 grid grid-cols-1 md:grid-cols-2 gap-2 text-sm' }, [
    spLink('n8n (workflow automation)', '/n8n/', 'gold'),
    spLink('Uptime Kuma (monitoring)', '/status/', 'green'),
    spLink('OpenClaw (IA multi-canal)', '/chat/', 'gold'),
    h('div', { class: 'flex items-center gap-2' }, ['Ollama (IA local): ', pill('qwen2.5:3b vivo', 'green')]),
  ]));
}

function spLink(label, url, color) {
  return h('div', { class: 'flex items-center gap-2' }, [
    h('a', { href: url, target: '_blank', class: 'text-gold-400 hover:text-gold-300 underline' }, label),
    pill('vivo', color),
  ]);
}

function passwordSection() {
  const sec = card('Cambiar contraseña');
  const cur = h('input', { type: 'password', placeholder: 'Contraseña actual', class: 'w-full bg-base-900 border border-base-600 rounded-lg px-3 py-2 text-sm mb-2' });
  const nw = h('input', { type: 'password', placeholder: 'Nueva contraseña (mín 8)', class: 'w-full bg-base-900 border border-base-600 rounded-lg px-3 py-2 text-sm mb-2' });
  const msg = h('div', { class: 'text-sm mb-2' });
  const button = btn('Actualizar', async () => {
    msg.innerHTML = ''; msg.className = 'text-sm mb-2';
    try {
      await apiClient.post('/api/v1/auth/change-password', { currentPassword: cur.value, newPassword: nw.value });
      msg.textContent = '✓ Contraseña actualizada';
      msg.className = 'text-sm mb-2 text-emerald-300';
      cur.value = ''; nw.value = '';
    } catch (e) {
      msg.textContent = e.message || 'Error';
      msg.className = 'text-sm mb-2 text-red-300';
    }
  });
  const body = h('div', { class: '-mt-3 mb-6 pl-5 max-w-md' }, [cur, nw, msg, button]);
  sec.appendChild(body);
  return sec;
}

async function twoFactorSection() {
  const sec = card('Autenticación de 2 factores (2FA)');
  const body = h('div', { class: '-mt-3 mb-6 pl-5 max-w-md' });
  sec.appendChild(body);

  const status = await apiClient.get('/api/v1/auth/2fa/status').catch(() => ({ enabled: false }));

  if (status.enabled) {
    body.appendChild(h('div', { class: 'text-sm mb-2' }, ['Estado: ', pill('ACTIVADO', 'green')]));
    const pwdInput = h('input', { type: 'password', placeholder: 'Tu contraseña para desactivar', class: 'w-full bg-base-900 border border-base-600 rounded-lg px-3 py-2 text-sm mb-2' });
    const msg = h('div', { class: 'text-sm mb-2' });
    body.appendChild(pwdInput);
    body.appendChild(msg);
    body.appendChild(btn('Desactivar 2FA', async () => {
      try {
        await apiClient.post('/api/v1/auth/2fa/disable', { password: pwdInput.value });
        msg.textContent = '✓ 2FA desactivado. Recarga.';
        msg.className = 'text-sm mb-2 text-emerald-300';
      } catch (e) {
        msg.textContent = e.message;
        msg.className = 'text-sm mb-2 text-red-300';
      }
    }, { variant: 'secondary' }));
  } else {
    body.appendChild(h('p', { class: 'text-sm text-ink-300 mb-2' }, 'Activa 2FA con Google Authenticator, Authy o 1Password.'));
    const startBtn = btn('Activar 2FA', async () => {
      try {
        const setup = await apiClient.post('/api/v1/auth/2fa/setup', {});
        body.innerHTML = '';
        body.appendChild(h('p', { class: 'text-sm mb-2' }, '1) Escanea este QR con tu app de autenticación:'));
        if (setup.qrCodeUrl) body.appendChild(h('img', { src: setup.qrCodeUrl, class: 'bg-white p-2 rounded-lg mb-2', width: '200' }));
        else body.appendChild(h('div', { class: 'space-y-2 mb-3' }, [
          h('a', { href: setup.uri, class: 'inline-block bg-gold-400 text-base-900 font-semibold px-4 py-2 rounded-lg' }, '📲 Abrir en mi app de autenticación'),
          h('div', { class: 'text-xs text-ink-300' }, 'O añade esta clave a mano (Google Authenticator, 1Password, Contraseñas de iPhone):'),
          h('code', { class: 'block bg-base-900 border border-base-700 rounded-lg px-3 py-2 text-gold-300 break-all select-all' }, setup.secret),
          h('div', { class: 'text-[11px] text-ink-400' }, 'Por privacidad, la clave no se envía a ningún servicio externo para generar el QR.'),
        ]));
        body.appendChild(h('p', { class: 'text-xs text-ink-400 mb-2' }, ['o secreto manual: ', h('code', { class: 'bg-base-900 px-2 py-1 rounded' }, setup.secret)]));
        body.appendChild(h('p', { class: 'text-sm mb-2' }, '2) Introduce el código de 6 dígitos:'));
        const codeInput = h('input', { type: 'text', maxlength: '6', placeholder: '000000', class: 'w-32 bg-base-900 border border-base-600 rounded-lg px-3 py-2 text-sm mb-2 font-mono text-center text-lg tracking-widest' });
        const msg = h('div', { class: 'text-sm mb-2' });
        body.appendChild(codeInput);
        body.appendChild(msg);
        body.appendChild(btn('Confirmar', async () => {
          try {
            await apiClient.post('/api/v1/auth/2fa/enable', { code: codeInput.value });
            msg.textContent = '✓ 2FA activado correctamente.';
            msg.className = 'text-sm mb-2 text-emerald-300';
          } catch (e) {
            msg.textContent = e.message;
            msg.className = 'text-sm mb-2 text-red-300';
          }
        }));
      } catch (e) {
        const { toast } = await import('./_common.js'); toast('Error: ' + e.message, 'error');
      }
    });
    body.appendChild(startBtn);
  }
  return sec;
}

function importSection() {
  const sec = card('Importar datos', { subtitle: 'Migra notas/tareas/etc desde el dashboard HTML viejo' });
  const fileInput = h('input', { type: 'file', accept: '.json,application/json', class: 'mb-2 text-sm' });
  const msg = h('div', { class: 'text-sm mb-2' });
  const button = btn('Importar JSON', async () => {
    const file = fileInput.files?.[0];
    if (!file) { msg.textContent = 'Selecciona un archivo JSON'; msg.className = 'text-sm mb-2 text-red-300'; return; }
    try {
      const text = await file.text();
      const data = JSON.parse(text);
      const res = await apiClient.post('/api/v1/import/from-html-dashboard', data);
      msg.innerHTML = '✓ Importado: ' + Object.entries(res.imported).map(([k, v]) => `${k}=${v}`).join(', ');
      msg.className = 'text-sm mb-2 text-emerald-300';
    } catch (e) {
      msg.textContent = 'Error: ' + e.message;
      msg.className = 'text-sm mb-2 text-red-300';
    }
  });
  const body = h('div', { class: '-mt-3 mb-6 pl-5 max-w-md' }, [fileInput, msg, button]);
  sec.appendChild(body);
  return sec;
}
